import { useMemo } from 'react';

import { codeBlock } from '@lumapps/lumx/custom-icons';
import { useTranslate } from '@lumapps/translations';
import { PARAGRAPH } from '@lumapps/wrex-typography/constants';
import { TypographyEditor } from '@lumapps/wrex-typography/types';
import { useSlate, useSlateStatic } from '@lumapps/wrex/slate';
import { focusAt } from '@lumapps/wrex/slate/utils/focusAt';
import { ToolbarItem, WrexEditor } from '@lumapps/wrex/types';

import { CODE_BLOCK } from '../../../constants';
import { WREX_CODE_BLOCK } from '../../../keys';

export const useCodeBlockButton = (otherProps?: any) => {
    const editor = useSlate() as WrexEditor<TypographyEditor>;
    const editorStatic = useSlateStatic() as WrexEditor<TypographyEditor>;

    const isCurrentNodeACodeBlock = editor.getBlockType() === CODE_BLOCK;
    const { translateKey } = useTranslate();

    const isSelected = isCurrentNodeACodeBlock;
    const isDisabled = !editor.isCodeBlockAllowed();

    return useMemo((): ToolbarItem => {
        return {
            type: 'toggle-option',
            itemKey: CODE_BLOCK,
            icon: codeBlock,
            label: translateKey(WREX_CODE_BLOCK.BUTTON_LABEL),
            tooltipLabel: translateKey(WREX_CODE_BLOCK.BUTTON_LABEL),
            variant: 'icon',
            onClick() {
                const at = editorStatic.selection || editorStatic.getLastSelection();

                if (editorStatic.getBlockType() === CODE_BLOCK) {
                    editorStatic.changeBlockType(PARAGRAPH, at);
                } else {
                    editorStatic.changeBlockType(CODE_BLOCK, at);
                }
                focusAt(editorStatic, editorStatic.selection);
            },
            'aria-disabled': isDisabled,
            isChecked: isSelected,
            otherProps,
        };
    }, [editorStatic, isDisabled, isSelected, otherProps, translateKey]);
};
